module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(['fromWX', 'fromBD', 'fromZFB', 'fromTT', 'fromTZ'].indexOf(_vm.pagefrom) === -1 && _vm.resumeType !== 3) ? _c('Nav') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b64dde5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/App.vue
// module id = 359
// module chunks = 0